export const ERROR_SERVICE_INCIDENT_TICKET_KEY = 'error_service_incident'

export const MEETING_TICKET_KEY = 'meeting'

/** TICKET TYPE GROUP DEFINED */
export const TICKET_TYPE_GROUP_MEETING = 'meeting'
export const TICKET_TYPE_GROUP_SUPPORT_REQUEST = 'support_request'
/** SERVICE TICKET TYPE KEYS */
export const SERVICE_CREATING_KEY = 'service_creating'
export const SERVICE_CANCELLED_KEY = 'service_cancelled'
export const SERVICE_SUSPEND_KEY = 'service_suspend'
export const SERVICE_CREATING_POC_KEY = 'service_creating_poc'

/** TICKET STATUS DEFINED */
/**
 * Opening: Ticket is being opened - Label hiển thị là "NEW"
 * Work in progress: Ticket is being worked on - Label hiển thị là "IN PROGRESS"
 * Completed: Ticket is completed - Label hiển thị là "RESOLVED"
 * Closed: Ticket is closed - Label hiển thị là "CLOSED"
 */
export const TICKET_STATUS_OPENING = 'opening'
export const TICKET_STATUS_WORK_IN_PROGRESS = 'work-in-progress'
export const TICKET_STATUS_COMPLETED = 'completed'
export const TICKET_STATUS_CLOSED = 'closed'
export const TICKET_STATUS_ESCALATED = 'escalated'

/** IT-ISMS: Security classification tag values per QT-01 §4.2 */
export const SECURITY_TAG_NONE = 'none'
export const SECURITY_TAG_SECURITY = 'security'
export const SECURITY_TAG_SERVICE = 'service'
export const SECURITY_TAG_BOTH = 'both'
